
import DrawBase from "../DrawBase"
import EditCone from "./EditCone"
import StyleUtil from "@/utils/cesiumBD/utils/StyleUtil.js"
class DrawCone extends DrawBase {

    getEditInterface() {
        return EditCone;
    }

    getTypeName() {
        return "圆锥";
    }
    getType() {
        return "cylinder_Nor";
    }

    checkLeftClick() {
        if (this.positionsTemp.length <= 1) {
            return true;
        }
        return false;
    }

    checkMouseMove() {
        if (this.positionsTemp.length <= 1) {
            return false;
        }
        return true;
    }

    addDynamicGraph(entity) {
        var $this = this;
        var positionsArr = undefined;
        var minR = 1;
        var positions = [];
        var bottomRadiusProperty = new $this.Cesium.CallbackProperty(function () {
            $this.calculateKeyPositions();
            if (!$this.isStarted && !positionsArr) {
                positionsArr = $this.positions.slice();
            }
            positions = positionsArr ? positionsArr : $this.positions;
            var center = positions[0];
            var outline = positions[1];

            var r = Cesium.Cartesian3.distance(center, outline);
            return r ? r : r + minR;
        }, false);

        var lengthProperty = new $this.Cesium.CallbackProperty(function () {

            var r = bottomRadiusProperty.getValue();
            return r ? r * 4 : minR;
        });

        var cylinder = this.createCone(lengthProperty, bottomRadiusProperty);
        entity.position = this.positionsTemp[0].clone();
        entity.cylinder = cylinder;

    }

    loadDynamicGraph(entity, data) {
        var $this = this;
        var minR = 1;
        var positions =  JSON.parse(data.editPositions);
        var bottomRadiusProperty = new $this.Cesium.CallbackProperty(function () {
            var center = positions[0];
            var outline = positions[1];

            var r = Cesium.Cartesian3.distance(center, outline);
            return r ? r : r + minR;
        }, true);

        var lengthProperty = new $this.Cesium.CallbackProperty(function () {
            var r = bottomRadiusProperty.getValue();
            return r ? r * 4 : minR;
        });

        var cylinder = this.createCone(lengthProperty, bottomRadiusProperty);
        entity.position = positions[0];
        entity.cylinder = cylinder;
        StyleUtil.setStyle2Entity(JSON.parse(data.styleAttr), entity, "cylinder")
    }
}

export default DrawCone;